
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import TruckZip3OverridesModule from "@/store/modules/truckZip3Overrides";
import Component from "vue-class-component";
import {
  TruckZip3Overrides,
  GetTruckZip3OverridesRequest,
  TruckZip3OverridesListItem
} from "@/models/api/truckZip3Overrides/getTruckZip3Overrides";
import { Watch } from "vue-property-decorator";
import notifications from "../../lib/notifications";

const truckZip3OverridesModuleState = getModule(TruckZip3OverridesModule);

@Component({})
export default class truckZip3Overridesummary extends Vue {
  showTruckTemplateFieldFilter: boolean = false;
  showtruckZip3Overrides: boolean = false;
  truckZip3OverridesMenuStyle: string = "";
  clickLocation: any = null;
  facilityCode: string = null;

  get truckZip3OverridesFields() {
    return truckZip3OverridesModuleState.truckZip3OverridesFields;
  }

  get pageNumber(): number {
    return truckZip3OverridesModuleState.pageData.currentPage;
  }

  set pageNumber(val) {
    truckZip3OverridesModuleState.setCurrentPage(val);
  }
  get pageSize(): number {
    return truckZip3OverridesModuleState.pageData.pageSize;
  }

  get totalItems(): number {
    return truckZip3OverridesModuleState.pageData.totalItems;
  }

  get loading(): boolean {
    return truckZip3OverridesModuleState.loading;
  }

  get truckZip3Overrides(): Array<TruckZip3OverridesListItem> {
    return truckZip3OverridesModuleState.data;
  }

  @Watch("pageNumber")
  pageChanged(val) {
    this.loadTruckZip3Overrides();
  }

  async created() {
    this.loadTruckZip3Overrides();
  }

  async loadTruckZip3Overrides() {
    await truckZip3OverridesModuleState.setLoading(true);
    await truckZip3OverridesModuleState.getTruckZip3OverridesList({
      pageNumber: this.pageNumber,
      pageSize: truckZip3OverridesModuleState.pageData.pageSize,
      facilityFilter: this.facilityCode
    } as GetTruckZip3OverridesRequest);
    await truckZip3OverridesModuleState.setLoading(false);
  }

  async deleteRecord(id: number) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      "Are you sure you want to delete this record? This action cannot be undone."
    );
    if (confirmed) {
      try {
        await truckZip3OverridesModuleState.deleteTruckZip3Overrides({
          truckZip3OverridesId: id,
          confirm: true
        });
        await this.loadTruckZip3Overrides();
        notifications.success("Delete Truck Zip3 Override", "Record successfully deleted.");
      } catch (ex) {
        notifications.error("Delete Truck Zip3 Override", "Failed to delete record", ex);
      }
    }
  }

  newTruckZip3Override() {
    this.$router.push({ name: "NewTruckZip3OverridesMaintenance" });
  }
}
